import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { cx } from '../../utils/cx';
import { Sidebar } from '../Sidebar';
import styles from './Shell.module.css';

// Стан шухляди тут: накладка й гамбургер малюються поверх усього каркаса.
export function Shell({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) {
      return;
    }
    function onKeyDown(event: KeyboardEvent): void {
      if (event.key === 'Escape') {
        setMenuOpen(false);
      }
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [menuOpen]);

  return (
    <div className={styles.app}>
      {/* Фіксований у лівому куті: там жодна сторінка нічого не малює. */}
      <button
        type="button"
        className={styles.burger}
        aria-label="Відкрити меню"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(true)}
      >
        <BurgerIcon />
      </button>

      {/* Суто візуальний шар — звідси `aria-hidden`. */}
      <div
        className={cx(styles.overlay, menuOpen && styles.overlayOpen)}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      <div className={cx(styles.sidebarSlot, menuOpen && styles.sidebarOpen)}>
        <Sidebar onClose={() => setMenuOpen(false)} />
      </div>

      <main className={styles.main}>{children}</main>
    </div>
  );
}

function BurgerIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
      <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
    </svg>
  );
}
